import { useCallback } from 'react';
import { FilterValues } from '../filters/types';
import { useActiveFilters } from './use-active-filters';
import { useCallIntelShallowStore } from './use-call-intel-store';

export const useNavigateToCallRecordsWithFilter = () => {
  const { setActiveTab } = useCallIntelShallowStore('setActiveTab');
  const { updateFilterValues } = useActiveFilters();

  const navigateToCallRecords = useCallback(
    (updatedFilters: Partial<FilterValues>) => {
      updateFilterValues(updatedFilters);
      setActiveTab('records');
    },
    [setActiveTab, updateFilterValues]
  );

  return { navigateToCallRecords };
};
